<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!--title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">{{ i18nValues["cropProduction"] }}</h4>
      </div>

      <!-- body -->
      <div class="grid-body no-border borderBottom">
        <el-form
          v-loading="loading != 0"
          :model="campaign"
          ref="formCampaign"
          :rules="rules"
        >
          <div style="width: 100; display: flex;">
            <div style="display:flex; flex-direction: column; width: 60%;">
              <div class="gridTemplate-small">
                <!-- FIELD -->
                <el-form-item
                  :label="i18nValues['field']"
                  class="label"
                  prop="field"
                >
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.field.id"
                      placeholder="Please select"
                      filterable
                      @change="changeFieldLots()"
                    >
                      <el-option
                        v-for="item in FieldsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.field"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.field.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- BATCH -->
                <el-form-item :label="i18nValues['batch']" prop="fieldLot">
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.fieldLot"
                      value-key="id"
                      filterable
                      placeholder="Please select"
                      @change="changeHAS()"
                    >
                      <el-option :value="null"></el-option>
                      <el-option
                        v-for="item in FieldLotsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.fieldLot"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.fieldLot.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- EXPERIMENTAL CODE -->
                <el-form-item
                  :label="i18nValues['experimentalCode']"
                  prop="product"
                >
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.product.id"
                      filterable
                      placeholder="Select"
                      v-on:change="changeProduct()"
                    >
                      <el-option
                        v-for="item in ProductList"
                        :key="item.id"
                        :label="item.experimentalCode"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.product"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.product.experimentalCode }}</a
                    >
                  </template>
                </el-form-item>

                <!-- VARIETY -->
                <el-form-item :label="i18nValues['variety']" prop="variable">
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.product.name"
                      disabled
                    ></el-input>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.product"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.product.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- BRAND -->
                <el-form-item label="Brand" prop="brand">
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.product.brand"
                      disabled
                    ></el-input>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.product"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.product.brand }}</a
                    >
                  </template>
                </el-form-item>

                <!-- EVENT -->
                <el-form-item :label="i18nValues['event']" prop="event">
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.product.event.name"
                      disabled
                    ></el-input>
                  </template>
                  <template v-else>
                    <a
                      v-if="cropProduction.product && cropProduction.product.event"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.product.event.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- CUSTOMER -->
                <el-form-item :label="i18nValues['customer']" prop="customer">
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.customer.id"
                      placeholder="Please select"
                      filterable
                    >
                      <el-option :value="null"></el-option>
                      <el-option
                        v-for="item in CustomersList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      v-if="cropProduction.customer"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.customer.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- STATUS -->
                <el-form-item :label="i18nValues['status']" prop="status">
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.status"
                      placeholder="Please select"
                      filterable
                    >
                      <el-option :value="null"></el-option>
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.status }}</a
                    >
                  </template>
                </el-form-item>

                <!-- COUNTRY -->
                <el-form-item :label="i18nValues['country']" prop="country">
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.country.id"
                      placeholder="Please select"
                      filterable
                    >
                      <el-option :value="null"></el-option>
                      <el-option
                        v-for="item in CountriesList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a v-if="cropProduction.country"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.country.name }}</a
                    >
                  </template>
                </el-form-item>

                <!-- PROJECT -->
                <el-form-item :label="i18nValues['project']" prop="project">
                  <template v-if="mode !== 'view'">
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <el-select
                        v-model="cropProduction.project"
                        placeholder="Please select"
                        filterable
                        value-key="id"
                        style="flex: 1;"
                      >
                        <el-option :value="null"></el-option>
                        <el-option
                          v-for="item in projects"
                          :key="item.id"
                          :label="item.name"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                      <el-button
                        v-if="cropProduction.product && cropProduction.product.id && cropProduction.fieldLot && cropProduction.fieldLot.id"
                        icon="el-icon-edit"
                        size="small"
                        @click="openLocationDialog"
                        :title="i18nValues['drawOnMap'] || 'Draw Location'"
                      >
                        {{ i18nValues['drawOnMap'] || 'Draw Location' }}
                      </el-button>
                    </div>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a v-if="cropProduction.project"
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.project.name }}</a>
                  </template>
                </el-form-item>
                
                <div></div>
                <div></div>

                <div><h6>Información Secundaria</h6></div>

                <div></div>
                <br />

                <!-- QTY PLANTED -->
                <el-form-item
                  :label="i18nValues['qtyToPlant']"
                  prop="qtyToPlant"
                >
                  <template v-if="mode !== 'view'">
                    <el-input v-model="cropProduction.qtyToPlant"></el-input>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.qtyToPlant }}</a
                    >
                  </template>
                </el-form-item>

                <!-- HAS -->
                <el-form-item :label="i18nValues['has']" prop="has">
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.has"
                      v-on:input="calculate()"
                      @keypress.native="isNumberWithDecimals($event)"
                    ></el-input>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.has }}</a
                    >
                  </template>
                </el-form-item>

                <!-- AC ON CHANGE CALCULATE-->
                <el-form-item :label="i18nValues['ac']" prop="ac">
                  <template v-if="mode !== 'view'">
                    <el-input v-model="cropProduction.ac" disabled></el-input>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.ac }}</a
                    >
                  </template>
                </el-form-item>

                <!-- ESTIMATED DATE PLANTED -->
                <el-form-item
                  :label="i18nValues['estimatePlantingDate']"
                  prop="estimatePlanting"
                >
                  <template v-if="mode !== 'view'">
                    <div class="input-group">
                      <el-date-picker
                        type="date"
                        class="calendar"
                        format="dd/MM/yyyy"
                        v-model="cropProduction.estimatePlanting"
                        placeholder="Select date"
                      >
                      </el-date-picker>
                      <span
                        class="input-group-addon primary el-input__suffix icon"
                      >
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ this.formatDate(cropProduction.estimatePlanting) }}</a
                    >
                  </template>
                </el-form-item>

                <!-- REAL DATE PLANTED -->
                <el-form-item
                  :label="i18nValues['realPlantingDate']"
                  prop="realPlanting"
                >
                  <template v-if="mode !== 'view'">
                    <div class="input-group">
                      <el-date-picker
                        type="date"
                        class="calendar"
                        format="dd/MM/yyyy"
                        v-model="cropProduction.realPlanting"
                        placeholder="Select date"
                      >
                      </el-date-picker>
                      <span
                        class="input-group-addon primary el-input__suffix icon"
                      >
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ this.formatDate(cropProduction.realPlanting) }}</a
                    >
                  </template>
                </el-form-item>

                <!-- IRRIGATION -->
                <el-form-item
                  :label="i18nValues['irrigation']"
                  prop="irrigation"
                >
                  <template v-if="mode !== 'view'">
                    <el-select
                      v-model="cropProduction.irrigation"
                      placeholder="Please select"
                      filterable
                    >
                      <el-option
                        v-for="item in IrrigationOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ irrigationLabel }}</a
                    >
                  </template>
                </el-form-item>

                <!-- ESTIMATED DATE HARVEST -->
                <el-form-item
                  :label="i18nValues['estimateHarvest']"
                  prop="estimateHarvest"
                >
                  <template v-if="mode !== 'view'">
                    <div class="input-group">
                      <el-date-picker
                        type="date"
                        class="calendar"
                        format="dd/MM/yyyy"
                        v-model="cropProduction.estimateHarvest"
                        placeholder="Select date"
                      >
                      </el-date-picker>
                      <span
                        class="input-group-addon primary el-input__suffix icon"
                      >
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ this.formatDate(cropProduction.estimateHarvest) }}</a
                    >
                  </template>
                </el-form-item>

                <!-- REAL DATE HARVEST -->
                <el-form-item
                  :label="i18nValues['realHarvest']"
                  prop="realHarvest"
                >
                  <template v-if="mode !== 'view'">
                    <div class="input-group">
                      <el-date-picker
                        type="date"
                        class="calendar"
                        format="dd/MM/yyyy"
                        v-model="cropProduction.realHarvest"
                        placeholder="Select date"
                      >
                      </el-date-picker>
                      <span
                        class="input-group-addon primary el-input__suffix icon"
                      >
                        <span class="arrow"></span>
                        <i class="fa fa-calendar-alt"></i>
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <!-- Display label text instead of the select -->
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ this.formatDate(cropProduction.realHarvest) }}</a
                    >
                  </template>
                </el-form-item>

                <!-- REAL HARVEST -->
                <el-form-item
                  :label="i18nValues['qtyRealHarvest']"
                  prop="qtyRealHarvest"
                >
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.qtyRealHarvest"
                      disabled
                    ></el-input>
                  </template>
                  <template v-else>
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.qtyRealHarvest }}</a
                    >
                  </template>
                </el-form-item>

                <!-- GM -->
                <el-form-item :label="i18nValues['gm']" prop="gm">
                  <template v-if="mode !== 'view'">
                    <el-input
                      v-model="cropProduction.product.gm"
                      disabled
                    ></el-input>
                  </template>
                  <template v-else>
                    <a
                      style="font-weight:lighter;line-height: 18px !important;font-size: 12px;"
                      >{{ cropProduction.product.gm }}</a
                    >
                  </template>
                </el-form-item>

                <!-- PRODUCTION PERFORMANCE ESTIMATED -->
                <!-- <el-form-item :label="i18nValues['productionPerformanceEstimate']" prop="productionPerformanceEstimate">
                            <el-input v-model="cropProduction.productionPerformanceEstimate" v-on:change="calculate()"></el-input>
                        </el-form-item> -->

                <!-- ESTIMATED HARVEST -->
                <!-- <el-form-item :label="i18nValues['qtyEstimateHarvest']" prop="qtyEstimateHarvest">
                            <el-input v-model="cropProduction.qtyEstimateHarvest" disabled></el-input>
                        </el-form-item> -->
              </div>
            </div>
            <Map
              v-if="renderMap && this.cropProduction.fieldLot"
              ref="mainMap"
              :key="mapKey"
              :fieldLot="this.cropProduction.fieldLot"
              style="width: 40% !important;height: 450px !important;display: inline-block; padding-left: 20px;"
            ></Map>
          </div>

          <ProductionEstimate
            v-if="!loadingData"
            ref="productionEstimate"
            :componentsMap="componentsMap"
            :cropProduction="this.cropProduction"
            :mode="mode"
          >
          </ProductionEstimate>

          <div></div>

          <h6 style="padding-top: 10px" v-if="this.MeasurementsList.length > 0">
            {{ i18nValues["variables"] }}
          </h6>

          <!-- VARIABLES -->
          <div class="full-width" style="margin:0 auto;">
            <el-table
              v-if="this.MeasurementsList.length > 0"
              :data="SummaryList"
              :row-class-name="tableRowClassName"
              :tree-props="{ children: 'children' }"
              :row-key="rowKeyGenerator"
              class="table table-hover table-striped"
              :empty-text="i18nValues['noDataAvailable']"
              align="center"
            >
              <!-- DATE-->
              <el-table-column
                prop="date"
                :label="i18nValues['date']"
                align="center"
                :formatter="formatDateRow"
                width="160"
              >
              </el-table-column>

              <!-- USER -->
              <el-table-column
                prop="user"
                :label="i18nValues['user']"
                align="center"
                width="120"
              >
              </el-table-column>

              <!--GENERATE COLUMNS BY VARIABLES (before combinations)-->
              <el-table-column
                v-for="item in columnsBeforeCombinations"
                :key="item.id"
                :prop="item.prop"
                :label="item.name"
                align="center"
                width="125"
              >
              </el-table-column>

              <!-- COMBINATIONS BUTTON (after 'preharvestOffTypePercentage') -->
              <el-table-column
                :label="i18nValues['combinations'] || 'Combinations'"
                width="125"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="hasCombinations(scope.row)"
                    type="text"
                    size="small"
                    icon="el-icon-more"
                    :title="i18nValues['viewCombinations'] || 'View combinations'"
                    @click="openCombinationDialog(scope.row)"
                  >
                  </el-button>
                </template>
              </el-table-column>

              <!--GENERATE COLUMNS BY VARIABLES (after combinations)-->
              <el-table-column
                v-for="item in columnsAfterCombinations"
                :key="item.id"
                :prop="item.prop"
                :label="item.name"
                align="center"
                width="125"
              >
              </el-table-column>

              <!-- DELETE -->
              <el-table-column width="90" align="right">
                <template slot-scope="scope" v-if="mode !== 'view'">
                  <el-button
                    v-if="!scope.row.isSummaryRow"
                    class="text-danger"
                    icon="fas fa-times"
                    size="small"
                    align="center"
                    :title="i18nValues['remove']"
                    @click="deleteVariable(scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- COMBINATIONS DETAIL DIALOG -->
          <el-dialog
            class="combo-dialog"
            :title="i18nValues['preharvestCombinations'] || 'Combinaciones pre-cosecha'"
            :visible.sync="comboDialogVisible"
            width="720px"
            center
            @close="closeCombinationDialog"
          >
            <div v-if="selectedComboMeasurement" class="combo-dialog-header">
              <span class="combo-dialog-date-label">
                {{ i18nValues['date'] || 'Fecha' }}:
              </span>
              <span class="combo-dialog-date-value">
                {{ formatDateRow(selectedComboMeasurement) || selectedComboMeasurement.date || '' }}
              </span>
            </div>

            <el-table
              :data="selectedCombinations"
              stripe
              class="table table-hover table-striped"
              style="width: 100%;"
              :empty-text="i18nValues['noDataAvailable']"
              align="center"
            >
              <el-table-column
                prop="comboIndex"
                :label="i18nValues['combination'] || 'Combinación'"
                width="110"
                align="center"
              />

              <el-table-column
                prop="pubescence"
                :label="i18nValues['pubescence'] || 'Pubescencia PB'"
                align="center"
                min-width="160"
              />

              <el-table-column
                prop="hiloColor"
                :label="i18nValues['hiloColor'] || 'Color del hilo'"
                align="center"
                min-width="160"
              />

              <el-table-column
                prop="podWallColor"
                :label="i18nValues['podWallColor'] || 'Color de la pared de la vaina'"
                align="center"
                min-width="180"
              />

              <el-table-column
                prop="percentage"
                :label="i18nValues['plantsCount'] || 'Cantidad de plantas'"
                width="160"
                align="right"
              />
            </el-table>
          </el-dialog>

          <Harvest
            v-if="!loadingData"
            ref="harvest"
            :componentsMap="componentsMap"
            :cropProduction="this.cropProduction"
            :destinations="this.destinations"
            :mode="mode"
          >
          </Harvest>

          <!-- CANCEL/SAVE -->
          <div class="full-width d-flex justify-content-end mt-2">
            <el-button
              :loading="loading"
              size="small"
              @click="cancel()"
              :class="mode === 'view' ? 'btn-primary' : ''"
            >
              {{ mode === 'view' ? i18nValues["back"] : i18nValues["cancel"] }}
            </el-button>
            <template v-if="mode !== 'view'">
              <el-button
                icon="fas fa-check"
                :loading="loading"
                size="small"
                class="btn-primary"
                @click="saveCropProduction()"
              >
                {{ i18nValues["save"] }}
              </el-button>
            </template>
          </div>
        </el-form>
      </div>
    </div>

    <!-- Location Drawing Dialog -->
    <el-dialog
      :title="i18nValues['drawOnMap'] || 'Draw Location'"
      :visible.sync="isLocationDialogOpen"
      width="90%"
      @close="closeLocationDialog"
      @opened="onLocationDialogOpened"
      class="location-dialog-modal"
    >
      <div class="location-dialog-content">
        <div class="location-dialog-left">
          <div class="location-dialog-actions">
            <el-button
              size="small"
              :type="isLocationDrawingMode ? 'success' : 'default'"
              icon="el-icon-edit"
              @click="toggleLocationDrawingMode"
              style="width: 100%;"
            >
              {{ isLocationDrawingMode
                ? (i18nValues['stopDrawing'] || 'Stop Drawing')
                : (i18nValues['drawOnMap'] || 'Draw on Map')
              }}
            </el-button>
            <el-upload
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="onLocationFileSelected"
              accept=".geojson,.json,.kml,.kmz"
              style="margin-top: 8px; width: 100%;"
            >
              <el-button
                size="small"
                icon="el-icon-upload"
                style="width: 100%;"
              >
                {{ i18nValues['uploadKML'] || 'Upload KML' }}
              </el-button>
            </el-upload>
            <div v-if="locationDraftError" class="text-danger location-dialog-error">
              {{ locationDraftError }}
            </div>
          </div>
        </div>
        <div class="location-dialog-right">
          <div v-if="!renderMap" style="height: 500px; display: flex; align-items: center; justify-content: center; color: #999;">
            Loading map...
          </div>
          <Map
            v-if="isLocationDialogOpen && renderMap && cropProduction.fieldLot"
            ref="locationMap"
            :key="'location-map-' + locationMapKey"
            mapId="location-map"
            :field="getFieldWithoutLots()"
            :fieldLot="cropProduction.fieldLot"
            :fieldLotsList="[]"
            :enableDrawing="isLocationDrawingMode"
            :showMarkers="true"
            @polygon-drawn="handleLocationPolygonDrawn"
            style="width: 100% !important;height: 500px !important;"
          ></Map>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeLocationDialog">
          {{ i18nValues['cancel'] || 'Cancel' }}
        </el-button>
        <el-button
          size="small"
          type="primary"
          :disabled="!!locationDraftError"
          @click="confirmLocationDialog"
        >
          {{ i18nValues['save'] || 'Save' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get } from "vuex-pathify";
import ProductionEstimate from "@/views/Campaign/ProductionEstimate.vue";
import Map from "@/components/map/Map.vue";
import Harvest from "@/views/Campaign/Harvest.vue";
export default {
  name: "ProductionEdition",

  created() {
    this.loadingData = true;
    if (this.id != 0) {
      this.retrieveById();
    } else {
      this.retrieveFields();
      this.cropProduction.campaign.id = this.idCampaign;
      this.loadingData = false;
    }
    // Capture initial query to preserve filters/pagination when returning
    this.returnQuery = { ...this.$route.query };

    this.rules = {
      // field: [{required: true, message: this.i18nValues["requiredValue"],trigger: "blur"}],
      // fieldLot: [{required: true, message: this.i18nValues["requiredValue"],trigger: "blur"}],
      // customer: [{required: true, message: this.i18nValues["requiredValue"],trigger: "blur"}],
      // product: [{required: true, message: this.i18nValues["requiredValue"],trigger: "blur"}],
      // country: [{required: true, message: this.i18nValues["requiredValue"],trigger: "blur"}],
    };

    this.retrieveMeasurements();
    this.retrieveProducts();
    this.retrieveCustomers();
    this.retrieveDestinations();
    this.retrieveCountries();
    this.retrieveProjects();
  },

  watch: {
    cropProduction: {
      handler() {
        this.renderMap = true;
      },
      deep: true,
    },
    mapKey() {
      // When map re-renders, re-add variety location if it exists
      this.$nextTick(() => {
        this.updateMainMapWithVarietyLocation();
      });
    },
  },

  components: {
    ProductionEstimate,
    Harvest,
    Map,
  },

  computed: {
    loading: get("campaign/loading"),
    globalCampaign: get("globalCampaign"),
    i18nValues: get("i18nStore/valuesRetrieved"),
    irrigationLabel() {
      const item = this.IrrigationOptions.find(
        (option) => option.value === this.cropProduction.irrigation
      );
      return item ? item.label : "";
    },
    // Columns before the combinations button (up to and including preharvestOffTypePercentage)
    columnsBeforeCombinations() {
      const idx = this.columns.findIndex(
        (c) => c.prop === "preharvestOffTypePercentage"
      );
      if (idx === -1) {
        return this.columns;
      }
      return this.columns.slice(0, idx + 1);
    },
    // Columns after the combinations button
    columnsAfterCombinations() {
      const idx = this.columns.findIndex(
        (c) => c.prop === "preharvestOffTypePercentage"
      );
      if (idx === -1) {
        return [];
      }
      return this.columns.slice(idx + 1);
    },
  },

  props: {
    id: null,
    idCampaign: null,
    componentsMap: {},
    mode: null,
  },

  data() {
    return {
      renderMap: false,
      campaign: {},
      mapKey: 0,
      cropProduction: {
        irrigation: "no",
        campaign: {},
        customer: {},
        country: {},
        product: {
          event: {},
        },
        field: {},
        fieldLot: {},
        has: 0,
        productionPerformanceEstimate: 0,
        productionEstimates: [],
        harvests: [],
        location: "",
      },

      ProductList: [],
      CustomersList: [],
      FieldsList: [],
      FieldLotsList: [],
      FieldLots: [],
      CountriesList:[
        {
          id: 1,
          name: 'Arg'
        },
        {
          id: 2,
          name: 'Bra'
        }
      ],

      options: [
        { value: "planned", label: "Planeado" },
        { value: "planted", label: "Sembrado" },
        { value: "toHarvest", label: "Para Cosechar" },
        { value: "harvested", label: "Cosechado" },
        { value: "shipmentToPlant", label: "Envio a Planta" },
        { value: "low", label: "Baja" },
      ],

      IrrigationOptions: [
        { value: "yes", label: "Si" },
        { value: "no", label: "No" },
      ],

      // Fixed order for dynamic measurement columns (after date & user)
      // Labels are resolved via i18nValues using i18nKey, with English fallbacks
      columnOrder: [
        {
          prop: "phenologicalStage",
          i18nKey: "phenologicalStage",
          fallback: "Phenological stage",
        },
        {
          prop: "observation",
          i18nKey: "comments",
          fallback: "Comments",
        },
        {
          prop: "plantStandPlantsPerHa",
          i18nKey: "plantsPerHa",
          fallback: "Plants per ha",
        },
        {
          prop: "plantStandAvgPlantsPerMeter",
          i18nKey: "plantsPerMeter",
          fallback: "Plants per meter",
        },
        {
          prop: "floweringOffTypePerThousand",
          i18nKey: "floweringOffTypePerThousand",
          fallback: "Off-type in flowering per 1000 plants",
        },
        {
          prop: "floweringOffTypePercentage",
          i18nKey: "floweringOffTypePercentage",
          fallback: "Off-type in flowering %",
        },
        {
          prop: "Aplicaciones",
          i18nKey: "applications",
          fallback: "Applications",
        },
        {
          prop: "Herbicide off type",
          i18nKey: "herbicideOffType",
          fallback: "Herbicide off type",
        },
        {
          prop: "preharvestOffTypePerThousand",
          i18nKey: "preharvestOffTypePerThousand",
          fallback: "Off-type pre-harvest per 1000 plants",
        },
        {
          prop: "preharvestOffTypePercentage",
          i18nKey: "preharvestOffTypePercentage",
          fallback: "Off-type pre-harvest %",
        },
        {
          prop: "Altas verdes",
          i18nKey: "altasVerdes",
          fallback: "Altas verdes",
        },
        {
          prop: "yieldResultKgPerHa",
          i18nKey: "yieldResultKgPerHa",
          fallback: "Estimated yield result (kg/ha)",
        },
      ],

      columns: [],
      variables: [{}],

      VariablesList: [{}],

      MeasurementsList: [],
      SummaryList: [],
      destinations: [],
      projects: [],
      returnQuery: {},
      isLocationDialogOpen: false,
      isLocationDrawingMode: false,
      locationDraftError: "",
      locationMapKey: 0,
      locationEditingGeometry: "",
      locationEditingFormat: "geojson",
      savedLocationGeometryBeforeDrawing: null,
      savedLocationFormatBeforeDrawing: null,
      newLocationDrawingCompleted: false,
      comboDialogVisible: false,
      selectedCombinations: [],
      selectedComboMeasurement: null,
    };
  },

  methods: {
    //AGREGA LOS PROPS FALTANTES A LA TABLA
    getProps() {
      // Fields to place at the end of the table (after all other columns)
      const endOfTableFields = [
        "yieldPlantsPerHa",
        "yieldGrainsPerPlant",
        "yieldThousandSeedWeight",
        "yieldStressFactor",
        "latitude",
        "longitude",
        "locationAccuracy",
        "locationProvider",
        "locationTime",
        "floweringTotalOffType",
        "floweringTotalPlants",
        "preharvestTotalOffType",
        "preharvestTotalPlants",
        "preharvestTotalCombinationPlants"
      ];
      const endOfTableFieldsSet = new Set(endOfTableFields);
      
      // Fields to completely exclude (never show as columns)
      const excludedFields = new Set([
        "preharvestCombinations"
      ]);

      // Collect all available dynamic fields (excluding fixed ones)
      const availableFields = new Set();
      const fieldHasValue = {};
      for (let i = 0; i < this.MeasurementsList.length; i++) {
        const m = this.MeasurementsList[i];
        for (const key in m) {
          if (
            key !== "id" &&
            key !== "date" &&
            key !== "user" &&
            key !== "performanceEstimate" &&
            key !== "qtyEstimateHarvest" &&
            !excludedFields.has(key)
          ) {
            availableFields.add(key);
            if (
              m[key] !== null &&
              m[key] !== undefined &&
              m[key] !== ""
            ) {
              fieldHasValue[key] = true;
            }
          }
        }
      }

      // Build columns in the desired fixed order, but only include
      // props that exist AND have at least one non-empty value
      // Skip endOfTableFields here - they will be added at the end
      this.columns = [];
      this.columnOrder.forEach((cfg) => {
        if (availableFields.has(cfg.prop) && fieldHasValue[cfg.prop] && !endOfTableFieldsSet.has(cfg.prop)) {
          const label =
            (this.i18nValues && this.i18nValues[cfg.i18nKey]) ||
            cfg.fallback ||
            cfg.prop;
          this.columns.push({
            id: cfg.prop,
            prop: cfg.prop,
            name: label,
          });
        }
      });

      // Add any remaining fields that weren't in the configuration (excluding endOfTableFields)
      for (const field of availableFields) {
        if (
          fieldHasValue[field] &&
          !this.columns.find(col => col.prop === field) &&
          !endOfTableFieldsSet.has(field)
        ) {
          this.columns.push({
            id: field,
            prop: field,
            name: field  // Use raw field name for unconfigured fields
          });
        }
      }

      // Add endOfTableFields at the very end (only if they have values)
      for (const field of endOfTableFields) {
        if (availableFields.has(field) && fieldHasValue[field]) {
          this.columns.push({
            id: field,
            prop: field,
            name: field  // Use raw field name
          });
        }
      }

      this.MeasurementsList.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        dateA.setHours(0, 0, 0, 0);
        dateB.setHours(0, 0, 0, 0);

        if (dateA.getTime() === dateB.getTime()) {
          const dateTimeComparison =
            new Date(b.date).getTime() - new Date(a.date).getTime();
          if (dateTimeComparison === 0) {
            return b.id - a.id;
          }
          return dateTimeComparison;
        }
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      if (this.MeasurementsList.length > 0) {
        this.addSummaryRow();
      }
    },

    retrieveMeasurements() {
      this.$store
        .dispatch("campaign/retrieveMeasurements", { id: this.id })
        .then((res) => {
          this.MeasurementsList = res;
          this.createObject();
        });
    },

    createObject() {
      for (var i = 0; i < this.MeasurementsList.length; i++) {
        for (
          var j = 0;
          j < this.MeasurementsList[i].dynamicVariables.length;
          j++
        ) {
          if (
            this.MeasurementsList[i].dynamicVariables[j]
              .dynamicVariableDefinition.dataType == 0
          ) {
            this.MeasurementsList[i][
              this.MeasurementsList[i].dynamicVariables[
                j
              ].dynamicVariableDefinition.name
            ] = this.MeasurementsList[i].dynamicVariables[j].stringValue;
          }
          if (
            this.MeasurementsList[i].dynamicVariables[j]
              .dynamicVariableDefinition.dataType == 1
          ) {
            this.MeasurementsList[i][
              this.MeasurementsList[i].dynamicVariables[
                j
              ].dynamicVariableDefinition.name
            ] = this.MeasurementsList[i].dynamicVariables[j].integerValue;
          }
          if (
            this.MeasurementsList[i].dynamicVariables[j]
              .dynamicVariableDefinition.dataType == 2
          ) {
            this.MeasurementsList[i][
              this.MeasurementsList[i].dynamicVariables[
                j
              ].dynamicVariableDefinition.name
            ] = this.MeasurementsList[i].dynamicVariables[j].doubleValue;
          }
          if (
            this.MeasurementsList[i].dynamicVariables[j]
              .dynamicVariableDefinition.dataType == 3
          ) {
            this.MeasurementsList[i][
              this.MeasurementsList[i].dynamicVariables[
                j
              ].dynamicVariableDefinition.name
            ] = this.MeasurementsList[i].dynamicVariables[j].stringValue;
          }
          if (
            this.MeasurementsList[i].dynamicVariables[j]
              .dynamicVariableDefinition.dataType == 4
          ) {
            this.MeasurementsList[i][
              this.MeasurementsList[i].dynamicVariables[
                j
              ].dynamicVariableDefinition.name
            ] = this.MeasurementsList[i].dynamicVariables[j].longValue;
          }
        }
        delete this.MeasurementsList[i].dynamicVariables;
      }
      this.getProps();
    },

    addSummaryRow() {
      let latestDate = null;
      for (const measurement of this.MeasurementsList) {
        if (!latestDate || new Date(measurement.date) > new Date(latestDate)) {
          latestDate = measurement.date;
        }
      }
      
      // Find the last measurement with combinations
      let lastMeasurementWithCombinations = null;
      let lastCombinationDate = null;
      for (const measurement of this.MeasurementsList) {
        if (
          measurement.preharvestCombinations &&
          Array.isArray(measurement.preharvestCombinations) &&
          measurement.preharvestCombinations.length > 0
        ) {
          if (!lastCombinationDate || new Date(measurement.date) > new Date(lastCombinationDate)) {
            lastCombinationDate = measurement.date;
            lastMeasurementWithCombinations = measurement;
          }
        }
      }
      
      const hardcodedRow = {};
      for (const measurement of this.MeasurementsList) {
        if (
          new Date(measurement.date).getTime() ===
          new Date(latestDate).getTime()
        ) {
          for (const key in measurement) {
            if (measurement[key] !== null && measurement[key] !== "") {
              hardcodedRow[key] = measurement[key];
            }
          }
        } else {
          for (const key in measurement) {
            if (
              measurement[key] !== null &&
              measurement[key] !== "" &&
              !hardcodedRow[key]
            ) {
              hardcodedRow[key] = measurement[key];
            }
          }
        }
      }
      
      // Override with the last available combinations if they exist
      if (lastMeasurementWithCombinations && lastMeasurementWithCombinations.preharvestCombinations) {
        hardcodedRow.preharvestCombinations = lastMeasurementWithCombinations.preharvestCombinations;
      }
      
      hardcodedRow.id = 0;
      hardcodedRow.date = latestDate;
      hardcodedRow.isSummaryRow = true;
      hardcodedRow.children = this.MeasurementsList;
      this.SummaryList.push(hardcodedRow);
    },

    tableRowClassName({ row }) {
      if (row.isSummaryRow) {
        return "summary-row";
      }
      return "";
    },

    rowKeyGenerator(row) {
      return row.isSummaryRow ? row.id + "_summary" : row.id;
    },

    hasCombinations(row) {
      return (
        row &&
        Array.isArray(row.preharvestCombinations) &&
        row.preharvestCombinations.length > 0
      );
    },

    openCombinationDialog(row) {
      // Simple debug: verify combinations data when opening dialog
      // eslint-disable-next-line no-console
      console.log("Opening combinations dialog for measurement:", {
        id: row && row.id,
        date: row && row.date,
        preharvestCombinations: row && row.preharvestCombinations,
      });
      this.selectedComboMeasurement = row;
      this.selectedCombinations = row.preharvestCombinations || [];
      this.comboDialogVisible = true;
    },

    closeCombinationDialog() {
      this.comboDialogVisible = false;
      this.selectedCombinations = [];
      this.selectedComboMeasurement = null;
    },

    saveCropProduction() {
      this.cropProduction.campaign.id = this.idCampaign;
      this.cropProduction.measurementBatches = this.MeasurementsList;
      this.$refs["formCampaign"].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch("campaign/saveCropProduction", this.cropProduction)
            .then((res) => {
              if (res.status == "OK") {
                this.$notify.success({
                  title: this.i18nValues["success"],
                  message: this.i18nValues["cropProductionSaved"],
                  position: "bottom-right",
                });
                this.cropProduction = { ...this.cropProduction };
                this.$router.push({ name: "ProductionAdmin", query: this.returnQuery });
              } else {
                this.$notify.error({
                  title: this.i18nValues["error"],
                  message: this.i18nValues["cantSaveCropProduction"],
                  position: "bottom-right",
                });
              }
            });
        }
      });
    },

    cancel() {
      this.$router.push({ name: "ProductionAdmin", query: this.returnQuery });
    },

    async retrieveById() {
      await this.retrieveFields();
      const res = await this.$store.dispatch(
        "campaign/retrieveCropProductionById",
        { id: this.id }
      );
      this.cropProduction = res;
      this.loadingData = false;
      this.renderMap = true;
      this.mapKey += 1;
      
      // Initialize null nested objects to prevent "Cannot read properties of null" errors
      if (this.cropProduction.field == null) {
        this.cropProduction.field = {};
      }
      if (this.cropProduction.product == null) {
        this.cropProduction.product = {};
      }
      if (this.cropProduction.customer == null) {
        this.cropProduction.customer = {};
      }
      if (this.cropProduction.country == null) {
        this.cropProduction.country = {};
      }
      
      for (var i = 0; i < this.FieldsList.length; i++) {
        if (this.cropProduction.field && this.cropProduction.field.id == this.FieldsList[i].id) {
          this.FieldLotsList = this.FieldsList[i].fieldLots;
        }
      }

      // Update main map with variety location if it exists
      this.$nextTick(() => {
        this.updateMainMapWithVarietyLocation();
      });
    },

    retrieveFields() {
      return this.$store.dispatch("field/retrieveFields").then((res) => {
        this.FieldsList = res;
        return res;
      });
    },

    retrieveFieldLots() {
      this.$store
        .dispatch("campaign/retrieveFieldLots", this.cropProduction.field.id)
        .then((res) => {
          this.FieldLots = res;
        });
    },

    retrieveProducts() {
      this.filter = {};
      this.filter.campaignId = this.globalCampaign
        ? this.globalCampaign.id
        : null;
      this.$store
        .dispatch("product/retrieveProducts", this.filter)
        .then((res) => {
          this.ProductList = res;
        });
    },

    retrieveCustomers() {
      this.$store.dispatch("customer/retrieveCustomers").then((res) => {
        this.CustomersList = res;
      });
    },

    retrieveDestinations() {
      this.$store.dispatch("campaign/retrieveDestinations").then((res) => {
        this.destinations = res;
      });
    },

    retrieveProjects() {
      this.$store.dispatch("campaign/retrieveProjects").then((res) => {
        this.projects = res;
      });
    },

    calculate() {
      this.cropProduction.ac =
        Math.round(this.cropProduction.has * 2.47 * 10) / 10;
      this.cropProduction.qtyEstimateHarvest =
        this.cropProduction.productionPerformanceEstimate *
        this.cropProduction.has;
      this.cropProduction.qtyEstimateHarvest = Math.round(
        this.cropProduction.qtyEstimateHarvest
      );
    },

    changeProduct() {
      //CHANGE BRAND AND EVENT
      for (var i = 0; i < this.ProductList.length; i++) {
        if (this.cropProduction.product.id == this.ProductList[i].id) {
          this.cropProduction.product.brand = this.ProductList[i].brand;
          this.cropProduction.product.event = this.ProductList[i].event;
          this.cropProduction.product.name = this.ProductList[i].name;
          this.cropProduction.product.gm = this.ProductList[i].gm;
        }
      }
    },

    changeFieldLots() {
      if (
        this.cropProduction.fieldLot != null &&
        this.cropProduction.id === 0
      ) {
        this.cropProduction.fieldLot = null;
      }
      this.retrieveFieldLots();
      for (var i = 0; i < this.FieldsList.length; i++) {
        if (this.cropProduction.field.id == this.FieldsList[i].id) {
          this.FieldLotsList = this.FieldsList[i].fieldLots;
        }
      }
    },

    changeHAS() {
      if (this.cropProduction.fieldLot != null) {
        this.cropProduction.has = this.cropProduction.fieldLot.dimensions;
        this.cropProduction.ac =
          Math.round(this.cropProduction.has * 2.47 * 10) / 10;
      }
    },

    formatDateRow(row) {
      if (!row || !row.date) {
        return '';
      }
      const formatted = this.formatDateHour(row.date);
      return formatted || row.date || '';
    },

    refreshSummaryRow() {
      // Step 1: Clear existing summary row(s). Assuming there's only one summary row
      this.SummaryList = [];

      // Step 2: Recalculate the summary information. Reusing logic from `addSummaryRow`
      let latestDate = null;
      for (const measurement of this.MeasurementsList) {
        if (!latestDate || new Date(measurement.date) > new Date(latestDate)) {
          latestDate = measurement.date;
        }
      }

      // Find the last measurement with combinations
      let lastMeasurementWithCombinations = null;
      let lastCombinationDate = null;
      for (const measurement of this.MeasurementsList) {
        if (
          measurement.preharvestCombinations &&
          Array.isArray(measurement.preharvestCombinations) &&
          measurement.preharvestCombinations.length > 0
        ) {
          if (!lastCombinationDate || new Date(measurement.date) > new Date(lastCombinationDate)) {
            lastCombinationDate = measurement.date;
            lastMeasurementWithCombinations = measurement;
          }
        }
      }

      const updatedSummaryRow = {};
      for (const measurement of this.MeasurementsList) {
        if (
          new Date(measurement.date).getTime() ===
          new Date(latestDate).getTime()
        ) {
          for (const key in measurement) {
            if (measurement[key] !== null && measurement[key] !== "") {
              updatedSummaryRow[key] = measurement[key];
            }
          }
        } else {
          for (const key in measurement) {
            if (
              measurement[key] !== null &&
              measurement[key] !== "" &&
              !updatedSummaryRow[key]
            ) {
              updatedSummaryRow[key] = measurement[key];
            }
          }
        }
      }

      // Override with the last available combinations if they exist
      if (lastMeasurementWithCombinations && lastMeasurementWithCombinations.preharvestCombinations) {
        updatedSummaryRow.preharvestCombinations = lastMeasurementWithCombinations.preharvestCombinations;
      }

      // Step 3: Update the summary row with recalculated values
      updatedSummaryRow.id = 0; // Ensure a unique identifier for the summary row, if necessary
      updatedSummaryRow.date = latestDate; // Set date to the latest measurement date
      updatedSummaryRow.isSummaryRow = true; // Mark this row as a summary row
      updatedSummaryRow.children = this.MeasurementsList; // Link to the original list, if needed

      // Add the updated summary row back to the SummaryList
      this.SummaryList.push(updatedSummaryRow);
    },

    deleteVariable(row) {
      this.$confirm(
        this.i18nValues["deleteVariableMessage"],
        this.i18nValues["deleteVariable"],
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.MeasurementsList.splice(this.MeasurementsList.indexOf(row), 1);
        this.refreshSummaryRow();
      });
    },

    retrieveCountries() {
      this.$store.dispatch("campaign/retrieveCountries").then((res) => {
        this.CountriesList = res;
      });
    },

    openLocationDialog() {
      if (!this.cropProduction.product || !this.cropProduction.product.id) {
        this.$notify.warning({
          title: this.i18nValues["warning"] || "Warning",
          message: this.i18nValues["selectVarietyFirst"] || "Please select a variety first",
          position: "bottom-right",
        });
        return;
      }
      // Check if field is selected
      if (!this.cropProduction.field || !this.cropProduction.field.id) {
        this.$notify.warning({
          title: this.i18nValues["warning"] || "Warning",
          message: this.i18nValues["selectFieldFirst"] || "Please select a field first",
          position: "bottom-right",
        });
        return;
      }
      // Check if fieldLot is selected
      if (!this.cropProduction.fieldLot || !this.cropProduction.fieldLot.id) {
        this.$notify.warning({
          title: this.i18nValues["warning"] || "Warning",
          message: this.i18nValues["selectBatchFirst"] || "Please select a batch first",
          position: "bottom-right",
        });
        return;
      }
      this.isLocationDialogOpen = true;
      this.locationEditingGeometry = this.cropProduction.location || "";
      this.locationEditingFormat = "geojson";
      this.locationDraftError = "";
      if (!this.renderMap) {
        this.renderMap = true;
      }
      // Increment map key to ensure fresh render with field data
      this.$nextTick(() => {
        this.locationMapKey += 1;
      });
    },

    closeLocationDialog() {
      this.clearLocationDraftPolygon();
      // If drawing was active but not completed, restore old geometry before closing
      if (this.isLocationDrawingMode && !this.newLocationDrawingCompleted && this.savedLocationGeometryBeforeDrawing) {
        this.locationEditingGeometry = this.savedLocationGeometryBeforeDrawing;
        this.locationEditingFormat = this.savedLocationFormatBeforeDrawing || "geojson";
      }
      this.isLocationDialogOpen = false;
      this.isLocationDrawingMode = false;
      this.locationDraftError = "";
      this.savedLocationGeometryBeforeDrawing = null;
      this.savedLocationFormatBeforeDrawing = null;
      this.newLocationDrawingCompleted = false;
      this.$nextTick(() => {
        if (this.renderMap) {
          this.locationMapKey += 1;
        }
      });
    },

    onLocationDialogOpened() {
      if (!this.renderMap) {
        this.renderMap = true;
      }
      this.$nextTick(() => {
        const m = this.$refs.locationMap;
        if (m) {
          // Wait for map to initialize and render the fieldLot
          // The map component will automatically call renderMapData() via watchers
          // when fieldLot prop is set, which will zoom to the fieldLot
          setTimeout(() => {
            // Load the location geometry if it exists (after fieldLot is rendered)
            if (m && this.locationEditingGeometry) {
              // Check if locationEditingGeometry is a GeoJSON string (starts with {) or KML
              // If it's a simple coordinate string like "lat,lon", skip loading it as geometry
              const isGeometryString = typeof this.locationEditingGeometry === "string" && 
                (this.locationEditingGeometry.trim().startsWith("{") || 
                 this.locationEditingGeometry.trim().startsWith("<"));
              
              if (isGeometryString) {
                // Detect format from the string
                let format = this.locationEditingFormat || "geojson";
                if (!format || format === "geojson") {
                  // Try to detect if it's KML
                  if (this.locationEditingGeometry.includes("<kml") || this.locationEditingGeometry.includes("<?xml")) {
                    format = "kml";
                  } else {
                    format = "geojson";
                  }
                }
                // Load geometry after ensuring fieldLot is rendered first
                // loadGeometryString will preserve fieldLot and re-zoom to it
                setTimeout(() => {
                  if (m && m.loadGeometryString) {
                    m.loadGeometryString(format, this.locationEditingGeometry);
                  }
                }, 300);
              }
            }
          }, 500);
        }
      });
    },

    toggleLocationDrawingMode() {
      if (this.isLocationDrawingMode) {
        // Stopping drawing mode
        if (!this.newLocationDrawingCompleted) {
          // No new drawing was completed, restore the old geometry
          if (this.savedLocationGeometryBeforeDrawing) {
            this.locationEditingGeometry = this.savedLocationGeometryBeforeDrawing;
            this.locationEditingFormat = this.savedLocationFormatBeforeDrawing || "geojson";
            
            // Reload the geometry on the map
            this.$nextTick(() => {
              const m = this.$refs.locationMap;
              if (m && m.loadGeometryString) {
                const format = this.savedLocationFormatBeforeDrawing || "geojson";
                m.loadGeometryString(format, this.savedLocationGeometryBeforeDrawing);
              }
            });
          }
        }
        // Reset flags
        this.savedLocationGeometryBeforeDrawing = null;
        this.savedLocationFormatBeforeDrawing = null;
        this.newLocationDrawingCompleted = false;
        this.isLocationDrawingMode = false;
      } else {
        // Starting drawing mode
        // Save current geometry before clearing
        const currentGeometry = this.locationEditingGeometry;
        if (currentGeometry) {
          this.savedLocationGeometryBeforeDrawing = currentGeometry;
          this.savedLocationFormatBeforeDrawing = this.locationEditingFormat || "geojson";
        } else {
          this.savedLocationGeometryBeforeDrawing = null;
          this.savedLocationFormatBeforeDrawing = null;
        }
        this.newLocationDrawingCompleted = false;
        this.isLocationDrawingMode = true;
      }
    },

    handleLocationPolygonDrawn(result) {
      if (result && result.success && result.geojson) {
        this.locationEditingGeometry = result.geojson;
        this.locationEditingFormat = "geojson";
        // Mark that a new drawing was completed
        this.newLocationDrawingCompleted = true;
        this.isLocationDrawingMode = false;
        this.locationDraftError = "";
        // Clear saved geometry since we're using the new one
        this.savedLocationGeometryBeforeDrawing = null;
        this.savedLocationFormatBeforeDrawing = null;
      } else if (result && result.message) {
        this.locationDraftError = result.message;
      } else {
        this.locationDraftError =
          this.i18nValues["boundaryRequired"] ||
          "Please draw a polygon on the map.";
      }
    },

    onLocationFileSelected(file) {
      const fileObj = file.raw || file;
      if (!fileObj) {
        this.locationDraftError = "Invalid file selected.";
        return;
      }

      const fileName = (fileObj.name || "").toLowerCase();
      const isKML = fileName.endsWith(".kml");
      const isKMZ = fileName.endsWith(".kmz");
      const isGeoJSON = fileName.endsWith(".geojson") || fileName.endsWith(".json");

      if (!isKML && !isGeoJSON && !isKMZ) {
        this.locationDraftError = "Unsupported file format. Please upload .geojson, .json, or .kml files.";
        return;
      }

      if (isKMZ) {
        this.locationDraftError = "KMZ files are not directly supported. Please extract the KML file from the KMZ archive and upload it.";
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const text = e.target.result;
          if (!text || typeof text !== "string") {
            this.locationDraftError = "Failed to read file content.";
            return;
          }

          const format = isKML ? "kml" : "geojson";
          
          // Validate the content by trying to parse it
          if (format === "geojson") {
            try {
              const parsed = JSON.parse(text);
              if (!parsed || (!parsed.type && !parsed.features && !parsed.geometry)) {
                throw new Error("Invalid GeoJSON structure");
              }
            } catch (parseError) {
              this.locationDraftError = "Invalid GeoJSON format. Please check the file.";
              // eslint-disable-next-line no-console
              console.error("GeoJSON parse error:", parseError);
              return;
            }
          } else if (format === "kml") {
            // Basic KML validation - check if it contains KML structure
            if (!text.includes("<kml") && !text.includes("<?xml")) {
              this.locationDraftError = "Invalid KML format. Please check the file.";
              // eslint-disable-next-line no-console
              console.error("KML validation failed - missing KML/XML structure");
              return;
            }
          }

          // Store the geometry string
          this.locationEditingGeometry = text;
          this.locationEditingFormat = format;

          // Load and display on the map
          const mapRef = this.$refs.locationMap;
          if (mapRef && mapRef.loadGeometryString) {
            const success = mapRef.loadGeometryString(format, text);
            if (success) {
              this.locationDraftError = "";
              this.isLocationDrawingMode = false;
            } else {
              this.locationDraftError = "Failed to load geometry from file. Please check the console for details.";
            }
          } else {
            this.locationDraftError = "Map not ready. Please try again.";
          }
        } catch (error) {
          this.locationDraftError = "Error processing file: " + (error.message || "Unknown error");
        }
      };

      reader.onerror = () => {
        this.locationDraftError = "Failed to read the file.";
      };

      reader.readAsText(fileObj);
    },

    clearLocationDraftPolygon() {
      if (this.$refs.locationMap && this.$refs.locationMap.clearDraftPolygon) {
        this.$refs.locationMap.clearDraftPolygon();
      }
    },

    confirmLocationDialog() {
      if (this.locationDraftError) {
        return;
      }

      if (!this.locationEditingGeometry) {
        this.locationDraftError = this.i18nValues["locationRequired"] || "Please draw or upload a location.";
        return;
      }

      // Save the location to cropProduction
      this.cropProduction.location = this.locationEditingGeometry;
      this.closeLocationDialog();
      
      // Update the main map to show the variety location
      this.updateMainMapWithVarietyLocation();
      
      this.$notify.success({
        title: this.i18nValues["success"] || "Success",
        message: this.i18nValues["locationSaved"] || "Location saved successfully",
        position: "bottom-right",
      });
    },

    getFieldWithoutLots() {
      // Return field object without fieldLots to prevent showing all lots in dialog
      if (!this.cropProduction.field) {
        return {};
      }
      const fieldCopy = { ...this.cropProduction.field };
      delete fieldCopy.fieldLots;
      return fieldCopy;
    },

    updateMainMapWithVarietyLocation() {
      // Wait for the map to be ready, then add the variety location
      this.$nextTick(() => {
        if (this.$refs.mainMap && this.cropProduction.location) {
          const varietyName = this.cropProduction.product && this.cropProduction.product.name 
            ? this.cropProduction.product.name 
            : (this.cropProduction.product && this.cropProduction.product.experimentalCode 
              ? this.cropProduction.product.experimentalCode 
              : "Variedad");
          
          // Wait a bit for the map to finish rendering fieldLot
          setTimeout(() => {
            if (this.$refs.mainMap && this.$refs.mainMap.addVarietyLocation) {
              this.$refs.mainMap.addVarietyLocation(this.cropProduction.location, varietyName);
            }
          }, 300);
        }
      });
    },
  },
};
</script>

<style>
.el-table .summary-row {
  background-color: #019e5a !important;
  color: #ffffff !important;
}
/* Keep summary row height similar even with text buttons */
.el-table .summary-row .el-button--text {
  padding: 0;
  line-height: normal;
  color: #ffffff;
}
.el-table .summary-row .el-button--text .el-icon-more {
  color: #ffffff;
}

label {
  font-weight: bold;
}
/* Remove bold from filter labels */
.filters-row label,
.filters-row /deep/ label {
  font-weight: normal !important;
}

.location-dialog-modal .el-dialog {
  max-width: 1800px;
}

.location-dialog-modal .el-dialog__body {
  padding: 24px;
  overflow: visible;
}

.location-dialog-modal .el-dialog__footer {
  padding: 15px 24px;
  border-top: 1px solid #e4e7ed;
  margin-top: 20px;
}

.location-dialog-content {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

.location-dialog-left {
  flex: 0 0 300px;
  min-width: 300px;
  max-width: 300px;
  padding-right: 20px;
}

.location-dialog-right {
  flex: 1;
  min-width: 0;
  min-height: 500px;
  margin-right: 20px;
}

.location-dialog-actions {
  margin-top: 0;
  padding: 0;
  text-align: left;
  margin-left: 20px;
}

.location-dialog-actions .el-button {
  width: 100% !important;
  display: block;
}

.location-dialog-actions .el-upload {
  width: 100%;
  display: block;
}

.location-dialog-error {
  margin-top: 12px;
  padding-left: 12px;
  font-size: 12px;
}

.combo-dialog .el-dialog__body {
  padding: 14px 20px 10px;
  background-color: #ffffff !important;
}

.combo-dialog .el-dialog {
  background-color: #ffffff !important;
}

.combo-dialog-header {
  margin-bottom: 8px;
  font-size: 12px;
  color: #606266;
  margin-left: 8px;
}

.combo-dialog-date-label {
  font-weight: 600;
  display: block;
  margin-right: 4px;
}

.combo-dialog-date-value {
  font-weight: 400;
  display: block;
  margin-top: 2px;
  min-height: 14px;
}

.combo-dialog .el-table {
  margin-top: 2px;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  background-color: #ffffff !important;
}

.combo-dialog .el-table__body-wrapper {
  background-color: #ffffff !important;
}

/* Ensure table body cells are not bold */
.combo-dialog .el-table__body td {
  font-weight: 400 !important;
}

.combo-dialog .el-table__body .cell {
  font-weight: 400 !important;
}
</style>
